document.addEventListener("DOMContentLoaded", function () {
    const video = document.getElementById("bombasticoVideo");

    document.querySelector(".video-play").addEventListener("click", () => {
        video.play();
    });

    document.querySelector(".video-pause").addEventListener("click", () => {
        video.pause();
    });

     document.querySelector(".pvb-mute-toggle").addEventListener("click", () => {
        video.muted = !video.muted;
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const video = document.querySelector(".pvb-video");
  if (!video) return;

  video.addEventListener("ended", () => {
    video.pause();          // sicherstellen, dass es stoppt
    video.currentTime = 0;  // zurück zum Anfang
  });
});